import type {
  CreateTechnicalUserRequest,
  UpdateTechnicalUserPasswordRequest,
  UpdateTechnicalUserRequest,
} from '@/types/api/admin'
import environment from '@/environments/environment.dev'

import HttpClient from '../apiHttpClient'

const TECHNICAL_USER_ENDPOINT = '/v1.0/technicaluser'

const fapiClient = new HttpClient(environment.adminFAPIUrl)

const createNewTechnicalUser = async (body: CreateTechnicalUserRequest) => {
  return fapiClient.post(`${TECHNICAL_USER_ENDPOINT}/create`, { body })
}

const getUserTechnicalById = async (userId: string) => {
  return fapiClient.get(`${TECHNICAL_USER_ENDPOINT}/${userId}`)
}

const updateTechnical = async (updatedData: UpdateTechnicalUserRequest) => {
  return fapiClient.put(`${TECHNICAL_USER_ENDPOINT}/update`, {
    body: updatedData,
  })
}

const deleteUserTechnical = async (userId: string) => {
  return fapiClient.delete(
    `${TECHNICAL_USER_ENDPOINT}/delete?userId=${userId}`,
  )
}

interface SetTechnicalUserPasswordParams {
  userId: string
  username: string
  password: string
}

const setTechnicalUserPassword = async ({
  userId,
  username,
  password,
}: SetTechnicalUserPasswordParams) => {
  const body: UpdateTechnicalUserPasswordRequest = {
    userId,
    userName: username,
    newPassword: password,
  }
  return fapiClient.post(`${TECHNICAL_USER_ENDPOINT}/update-password`, {
    body,
  })
}

export const adminFapiTechnicalUser = {
  createNewTechnicalUser,
  getUserTechnicalById,
  updateTechnical,
  deleteUserTechnical,
  setTechnicalUserPassword,
}
